import React from 'react'
import WhoHero from '../../Components/who/WhoHero'
import { Briefcase, Share2, Monitor, Factory, RotateCw } from 'lucide-react';
import UserFirstExperienceSection from '../../Components/servicex/UserFirstExperienceSection'
import ServiceX360ViewSection from '../../Components/servicex/ServiceX360ViewSection'
import ServiceXOfferingsSection from '../../Components/servicex/ServiceXOfferingsSection'
import IndustriesServiceExperienceSection from '../../Components/servicex/IndustriesServiceExperienceSection'
import WhatSetsApartSection from '../../Components/servicex/WhatSetsApartSection'
import OtherExpertLedSolutionsSection from '../../Components/servicex/OtherExpertLedSolutionsSection'
import CaseStudySection from '../../Components/servicex/CaseStudySection'
import FAQSection from '../../Components/servicex/FAQSection'

const serviceItems = [
    {
        id: 1,
        title: "Now Assist",
        description: "Accelerate productivity with generative AI built into the Now Platform. Now Assist delivers context-aware suggestions, summaries, and intelligent recommendations across IT, HR, Customer Service, and beyond—helping your teams work smarter and faster.",
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 2,
        title: "AI Agents",
        description: "AI Agents are autonomous, task-oriented assistants that handle routine requests end-to-end. From resolving incidents to completing transactions, these agents drive efficiency and improve response times across departments.",
        image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 3,
        title: "Virtual Agent",
        description: "Deliver 24/7 support with natural, conversational AI. Virtual Agent automates common service requests through chat, empowering employees and customers to get instant help while reducing case volume for your teams.",
        image: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 4,
        title: "AI Control Tower",
        description: "Take command of your enterprise AI initiatives with a centralized, intelligent control hub. AI Control Tower enables you to automate AI workflows end to end, monitor model performance, manage risks, and ensure compliance. Gain full visibility and governance to scale AI confidently, responsibly, and with measurable business impact.",
        image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=1000&q=80"
    }
];


const solutionsData = [
    {
        id: 1,
        title: "ServiceX",
        desc: "Deliver connected service experiences across IT, workplace, customer operations, and field teams to improve engagement and performance.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: 2,
        title: "Intelligent Operations",
        desc: "Modernize enterprise operations with connected workflows, real-time visibility, and automation that improves service performance and operational efficiency.",
        image: "/assets/mumbai/item9.png",
        link: "#"
    },
    {
        id: 3,
        title: "Risk and Security",
        desc: "Strengthen governance, compliance, and resilience through integrated risk workflows that reduce exposure and protect critical business services.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    }
];

const offeringsData = [
    {
        id: 1,
        title: "AI Strategy Roadmap",
        desc: "We work with you to define a clear, customized AI vision aligned with your business goals—backed by strategic planning and measurable outcomes.",
        image: "/assets/services/ai-strategy.png",
        products: []
    },
    {
        id: 2,
        title: "AI Development",
        desc: "From custom workflows to prebuilt AI models, we design, build, and deploy ServiceNow AI solutions that deliver real-time impact across your enterprise.",
        image: "/assets/services/ai-development.png",
        products: []
    },
    {
        id: 3,
        title: "AI Readiness Assessment",
        desc: "We evaluate your current systems, data infrastructure, and organizational maturity to ensure you're set up for successful AI adoption and scalability.",
        image: "/assets/services/ai-readiness.png",
        products: []
    }
];


const industryTabs = [
    {
        id: "it-operations",
        label: "IT Operations",
        title: "IT Operations",
        desc: "Leverage Predictive Intelligence to proactively identify and resolve issues, minimizing downtime and enhancing service reliability.[cite: 27]",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: "customer-service",
        label: "Customer Service",
        title: "Customer Service",
        desc: "Deploy Virtual Agents to provide instant, 24/7 support, reducing case volumes and improving customer satisfaction.[cite: 27]",
        image: "/assets/mumbai/item1.png",
        link: "#"
    },
    {
        id: "human-resources",
        label: "Human Resources",
        title: "Human Resources",
        desc: "Automate onboarding, manage employee inquiries, and personalize HR services, fostering a more engaged workforce.[cite: 27]",
        image: "/assets/mumbai/item5.png",
        link: "#"
    },
    {
        id: "security-operations",
        label: "Security Operations",
        title: "Security Operations",
        desc: "Utilize AI-driven analytics to detect threats, automate incident responses, and maintain robust security postures.[cite: 27]",
        image: "/assets/mumbai/item9.png",
        link: "#"
    },
    {
        id: "finance-procurement",
        label: "Finance and Procurement",
        title: "Finance and Procurement",
        desc: "Streamline invoice processing and procurement workflows through intelligent automation, enhancing accuracy and efficiency.[cite: 27]",
        image: "/assets/mumbai/item2.png",
        link: "#"
    },
    {
        id: "facilities-management",
        label: "Facilities Management",
        title: "Facilities Management",
        desc: "Optimize space utilization and maintenance schedules with AI-powered insights, ensuring operational excellence.[cite: 27]",
        image: "/assets/mumbai/item7.png",
        link: "#"
    }
];

const apartData = [
    {
        id: 1,
        title: "52%",
        desc: "Reduction in time to resolve complex cases.[cite: 28]"
    },
    {
        id: 2,
        title: "22%",
        desc: "Increase in operational efficiency across departments.[cite: 28]"
    },
    {
        id: 3,
        title: "30%",
        desc: "Decrease in manual task workloads, freeing up employee time for strategic activities.[cite: 28]"
    },
    {
        id: 4,
        title: "40%",
        desc: "Improvement in customer satisfaction scores due to faster and more accurate service delivery.[cite: 28]"
    }
];

const caseStudies = [
    {
        id: 'virgin',
        name: 'Virgin Mobile',
        logoText: 'Virgin Mobile',
        image: '/assets/mumbai/img1.png',
        title: 'Unified IT and Customer Service Operations on ServiceNow for Virgin Mobile UAE',
        desc: 'Reduced service friction, improved operational efficiency, and enhanced customer satisfaction within six months of go-live.',
        link: '#',
        badges: [
            'Deflection in 730 cases',
            'Reduction in agent attrition',
            'Reduction in unfavorable experiences'
        ]
    },
    {
        id: 'ansr',
        name: 'ANSR',
        logoText: 'ANSR',
        image: '/assets/mumbai/img2.png',
        title: 'AI-Enabled Service Operations for ANSR',
        desc: 'Leveraged automation and self-service to reduce manual effort and enhance service delivery across functions.',
        link: '#',
        badges: [
            'Faster Resolution',
            'Improved Employee Satisfaction',
            'Reduced Operational Costs'
        ]
    },
    {
        id: 'entain',
        name: 'Entain',
        logoText: 'Entain',
        image: '/assets/mumbai/img3.png',
        title: 'Enterprise HR Policy Governance Transformation for Entain',
        desc: 'Aligned policy lifecycle with knowledge visibility to ensure consistency, control, and better access management.',
        link: '#',
        badges: [
            'Automated the entire policy lifecycle',
            'Aligned HR policies with governance',
            'Controlled Knowledge Base visibility'
        ]
    },
    {
        id: 'maruti',
        name: 'MARUTI SUZUKI',
        logoText: 'Maruti Suzuki',
        image: '/assets/mumbai/img4.png',
        title: 'Streamlined Dealer Finance & Audit Operations for Maruti Suzuki',
        desc: 'Enabled faster processing, real-time financial insights, and improved compliance across dealer networks.',
        link: '#',
        badges: [
            'Reduced Turnaround Time (TAT)',
            'Enhanced Transparency & Audit Readiness',
            'Instant financial exposure insights'
        ]
    }
];

const faqData = [
    {
        id: 1,
        question: "How does ServiceNow AI work with ServiceNow's Core Products?",
        answer: "ServiceNow AI enhances core products by embedding intelligence into workflows. This includes AI Search for relevant information, AI-powered virtual agents for self-service, and predictive intelligence for proactive issue resolution and automation recommendations."
    },
    {
        id: 2,
        question: "What is ServiceNow Agentic AI?",
        answer: "ServiceNow Agentic AI refers to autonomous, goal-oriented AI agents capable of planning, reasoning, and executing complex multi-step tasks across systems without requiring constant manual intervention, dramatically speeding up resolution and operational productivity."
    },
    {
        id: 3,
        question: "How Does ServiceNow AI Works?",
        answer: "ServiceNow AI works by natively analyzing enterprise workflow and interaction data using purpose-built machine learning and large language models (LLMs). It automates routine requests, delivers contextual summaries via Now Assist, routes tasks intelligently, and continuously learns to optimize process outcomes."
    },
    {
        id: 4,
        question: "Difference Between GenAI and AI?",
        answer: "Traditional AI focuses on analyzing existing data to recognize patterns, make predictions, and automate rules-based decisions (e.g., ticket categorization or anomaly detection). Generative AI (GenAI) goes a step further by generating entirely new content, such as contextual summaries, automated code, and conversational responses based on natural language prompts."
    }
];


function ServicenowAi() {
    return (
        <div>
            <WhoHero
                title="Bring Intelligence with ServiceNow AI"
                text="Reimagine your enterprise transformation with ServiceNow AI and Aelum"
                imgData="/assets/glodesk/bg2.png"
            />
            <UserFirstExperienceSection title="Your productivity with ServiceNow AI" description="The AI era is advancing faster than we ever imagined, quickly becoming the driving force behind modern enterprises—fuelling progress with every insight and breakthrough. The real advantage lies in how efficiently and effectively an organization delivers value to both its customers and employees. To make impossible possible, businesses need a trusted partner like Aelum Consulting to shape and implement AI solutions that carve out a unique, transformative path. With the power of ServiceNow AI, we connect and automate workflows across your entire enterprise, unifying AI, data, and processes on a single, intelligent platform. This seamless integration not only streamlines operations but also empowers your teams to focus on what truly matters—driving growth and delivering exceptional value." />
            <ServiceX360ViewSection title="ServiceNow AI Capabilities" description="See how ServiceNow AI features are helping businesses work smarter, solve problems faster, and deliver better experiences." serviceItems={serviceItems} />
            <ServiceXOfferingsSection offeringsData={offeringsData} title="Our ServiceNow AI Services" description="See how ServiceNow AI features are helping businesses work smarter, solve problems faster, and deliver better experiences." />
            <IndustriesServiceExperienceSection title="ServiceNow AI for Every Corner of Your Business" industryTabs={industryTabs} />
            <WhatSetsApartSection title="Key Metrics and Impact" description="Organizations leveraging ServiceNow AI have reported " apartData={apartData} />
            {/* <OtherExpertLedSolutionsSection title="Other Expert-led Solutions" description="   Accelerate enterprise transformation with integrated, intelligent workflows engineered to drive operational resilience and business value." solutionsData={solutionsData} /> */}
            <CaseStudySection title="Real-World Case Studies" description=" See how we help global enterprises drive measurable operational outcomes and unified service delivery." caseStudies={caseStudies} />
            <FAQSection faqData={faqData} />
        </div>
    )
}

export default ServicenowAi
